/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteEsternoEditDto } from '../../models/utente-esterno-edit-dto';

export interface ApiAuthUtenteEsternoUpdatePatch$Params {
    /**
     * Lista dei permessi associati ad un utente
     */
    body: UtenteEsternoEditDto;
}

export function apiAuthUtenteEsternoUpdatePatch(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthUtenteEsternoUpdatePatch$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteEsternoUpdatePatch.PATH, 'patch');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiAuthUtenteEsternoUpdatePatch.PATH = '/api/auth/utente-esterno-update';
